































import Vue, { PropType } from 'vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import MultiFilterItem from '@/classes/MultiFilterItem';
import { FilterDefaults } from '@/types/constants/TableConstants';
import { ObjectUtils } from '@/utils/objectUtils';

export default Vue.extend({
  name: 'MStoreMultiFilter',
  props: {
    columnCount: {
      type: Number,
      required: true
    },
    multiFilterItems: {
      type: Array as PropType<MultiFilterItem[]>
    }
  },
  data() {
    return {
      filterDefaultElementId: FilterDefaults.ElementId,
      filters: [new MultiFilterItem()]
    };
  },
  mounted() {
    if (this.multiFilterItems) {
      this.filters = ObjectUtils.deepCloneObject(this.multiFilterItems);
    }
  },
  methods: {
    emitFilters(this: any) {
      this.$emit('filters', this.filters);
    },
    addFilter(this: any) {
      this.filters.push(new MultiFilterItem());
    },
    removeFilter(this: any, filter: MultiFilterItem) {
      this.filters = this.filters.filter((f: MultiFilterItem) => f !== filter);
      this.emitFilters();
    },
    clearFilters(this: any) {
      for (const f of this.filters) {
        f.value = '';
      }
      this.emitFilters();
    },
    resetFilters(this: any) {
      this.filters[0].value = '';
      this.filters.splice(1);
    }
  },
  computed: {
    maxFiltersReached(this: any) {
      return this.filters.length >= this.columnCount;
    },
    multipleFilters(this: any) {
      return this.filters.length > 1;
    },
    filtersHaveValue(this: any) {
      return this.filters.some((f: MultiFilterItem) => f.value);
    },
    filtersCanBeCleared(this: any) {
      return this.multipleFilters || this.filtersHaveValue;
    }
  },
  watch: {
    filters: {
      handler() {
        this.emitFilters();
      },
      deep: true
    }
  },
  components: {
    MStoreFilter
  }
});
